import React, { useState, useEffect, useRef } from 'react'

import { pdfjs, Document, Page } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export default function RenderPDFWidget(props) {
  const { fileName, file } = props
  const [numPages, setNumPages] = useState(null)

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
  }

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth])

  const onDownload = async (fileObj) => {
    // console.log('fileObj', fileObj)
    const url = window.URL.createObjectURL(fileObj)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName || 'preview_PDF')
    document.body.appendChild(link)
    link.click()
  }

  return (
    <>
      <div ref={containerRef}>
        <Document
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(e) => {
            console.log('onLoadError', e)
          }}
          noData={'--- ไม่พบไฟล์ PDF ---'}
        >
          {Array.apply(null, Array(numPages))
            .map((x, i) => i + 1)
            .map((page) => (
              <Page
                pageNumber={page}
                wrap={true}
                key={page}
                width={containerWidth > 500 ? containerWidth - 50 : 350}
              />
            ))}
        </Document>
      </div>
    </>
  )
}
